const testForms = (state = {}, action) => {
  const oldForm = { ...state[action.form] };
  const oldValues = { ...(oldForm.values || {}) };
  const newActions = { ...(action.data && action.data.actions ? action.data.actions : {}) };
  switch (action.type) {
    case 'UPDATE_FORMS':
      return {
        ...state,
        [action.form]: {
          values: { ...oldValues, ...action.data.values },
          errors: (action.data && action.data.errors) || {},
          actions: { ...(oldForm.actions || {}), ...newActions },
        },
      };
    default:
      return state;
  }
};
export default testForms;
